<template>
	<div class="msgmainbox">
		<div @click="closebigimg" v-if="isbigimg" class="bigimgbox">
			<div style="padding: 20px;">
				<div @click.self="clickimg" class="bigimgview"><img @click.stop="" :src="bigimgdata"></img></div>
			</div>
		</div>
		<div v-if="openimpage == true" class="impagebox" :class="{'openimdh':openimpage}">
			<component :refim="refim" :sendim_to_id="sendim_to_id" @showbigimg="showbigimg" @closeimpage="closeimpage"
			 @closemsgcenter="closemsgcenter" :is="impage"></component>
		</div>
		<div class="msgpagebox">
			<component @sendim="sendim" :refresh="refresh" :listrefim="listrefim" @msgnum="msgnum" @closemsgcenter="closemsgcenter"
			 :is="page"></component>
		</div>

		<div class="msgfooter">
			<div @click="msgnav(0)" :class="{'active':active==0}">
				<el-badge :value="newmsg">
					<i class="el-icon-message"></i>
				</el-badge>

			</div>
			<div @click="msgnav(1)" :class="{'active':active==1}"><i class="el-icon-user"></i></div>
			<div @click="msgnav(2)" :class="{'active':active==2}">
				<el-badge :value="newim">
					<i class="el-icon-chat-dot-square"></i>
				</el-badge>

			</div>
			<div @click="msgnav(3)" :class="{'active':active==3}"><i class="el-icon-set-up"></i></div>
		</div>

	</div>
</template>

<script>
	import setlist from "./SetList.vue";
	import impage from "./ImPage.vue";
	import msgpage from "./MsgPage.vue";
	import imuser from "./ImUser.vue";
	import imlist from "./ImList.vue";
	export default {
		props: ['refresh', 'refim', 'changepage'],
		components: {
			impage,
			msgpage,
			imuser,
			imlist,
			setlist

		},
		watch: {
			refresh() {
				this.pagerefresh = Math.random();
			},
			refim() {
				this.listrefim = Math.random();
				this.getimnum();
			}
		},
		data() {
			return {
				impage: impage,
				active: 0,
				page: msgpage,
				pagerefresh: 0,
				listrefim: 0,
				newmsg: 0,
				newim: 0,
				openimpage: false,
				sendim_to_id: 0,
				isbigimg: false,
				bigimgdata: ''
			}
		},
		methods: {
			closebigimg() {
				this.isbigimg = false;
				this.bigimgdata = '';
			},
			showbigimg(imgdata) {
				if (imgdata) {
					this.bigimgdata = imgdata;
					this.isbigimg = true;
				}
			},
			closeimpage() {
				this.openimpage = false;
				this.impage = '';
				this.listrefim = Math.random();
				this.getimnum();
			},
			sendim(to_id) {
				this.impage = impage;
				this.sendim_to_id = to_id;
				this.openimpage = true;
			},
			msgnav(navnum) {
				switch (navnum) {
					case 0:
						this.active = 0;
						this.page = msgpage;
						break;
					case 1:
						this.active = 1;
						this.page = imuser;
						break;
					case 2:
						this.active = 2;
						this.page = imlist;
						break;
					case 3:
						this.active = 3;
						this.page = setlist;
						break;
				}
			},
			msgnum() {
				this.getmessagenum();
			},
			closemsgcenter() {
				this.$emit('closemsgcenter', false);
			},
			getmessagenum() {
				let user_id = parseInt(this.sessionRead('user_id'));
				this.post('/api/message/getmessagenum', {
					to_id: user_id
				}).then((res) => {

					if (res) {
						this.newmsg = res;
					} else {
						this.newmsg = 0;
					}
				})
			},
			getimnum() {
				let user_id = parseInt(this.sessionRead('user_id'));
				this.post('/api/im/imnum', {
					user_id: user_id
				}).then((res) => {
					this.newim = res;
				})
			},
		},
		created() {
			this.getimnum();
			this.getmessagenum();
			if (this.changepage == 'imlist') {
				this.active = 2;
				this.page = imlist;
			}
		}
	}
</script>

<style scoped>
	.bigimgbox {
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		left: 0;
		top: 0;
		background: rgba(0, 0, 0, 0.4);
		z-index: 99999;
	}

	.bigimgview {
		max-width: 1000px;
		border-radius: 10px;
		border: 10px solid #fff;
	}

	.bigimgview>img {
		width: 100%;
	}

	@keyframes openimpagedh {
		0% {
			transform: translate3d(300px, 0, 0)
		}

		100% {
			transform: translate3d(0px, 0, 0)
		}
	}

	.openimdh {
		animation: openimpagedh 0.3s;
	}

	.impagebox {
		background: #fff;
		position: absolute;
		z-index: 999;
		width: 100%;
		height: 100%;
	}

	.msgmainbox {
		position: relative;
		height: 100%;
	}

	.msgfooter {
		display: flex;
		justify-content: space-between;
		padding: 0 20px;
		padding-top: 10px;
	}

	.msgfooter i {
		font-size: 20px;
	}

	.msgfooter .active {
		color: #3386f7;
	}

	.msgpagebox {
		height: calc(100vh - 40px);
		position: relative;
	}
</style>
